import styled from 'styled-components';

export const TagContainer = styled.div`
  .tag {
    padding: 4px 12px 4px 8px;
    border-radius: 1rem;
    background: #e1f7f2;
    max-width: 194px;

    label {
      text-transform: none;
      /* overriding label defaults */
      font-weight: 300 !important;
    }

    svg {
      fill: #01755b;
    }
  }
`;
